import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { getMeetingTitleByMeeting } from 'app/utils/appHelpers';

function ReportDecisionCountInfoTable({ data }) {
  const includeSameCount = data.some(item => Number(item.sameCount) > 0);
  const includeSaltCount = data.some(item => Number(item.saltCount) > 0);

  return (
    <>
      <Typography variant="h6" align="center">
        {data.length > 0 ? getMeetingTitleByMeeting(data[0]) : ""}
      </Typography>
      <Table size="small" sx={{ borderRadius: 3 }}>
        <TableHead sx={{ backgroundColor: "lightgrey" }}>
          <TableRow>
            <TableCell align="left" sx={{  }}>Konu</TableCell>
            <TableCell align="left" sx={{  }}>Madde Sayısı</TableCell>
            <TableCell align="left" sx={{  }}>Kabul Sayısı</TableCell>
            <TableCell align="left" sx={{  }}>Ret Sayısı</TableCell>
            {includeSameCount && (
              <TableCell align="left" sx={{  }}>Eşit Oy Sayısı</TableCell>
            )}
            {includeSaltCount && (
              <TableCell align="left" sx={{  }}>Salt Çoğunluk Sağlanamadı Sayısı</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index}>
              <TableCell align="left" sx={{  }}>{item.subjectName}</TableCell>
              <TableCell align="left" sx={{  }}>{item.decisionCount}</TableCell>
              <TableCell align="left" sx={{  }}>{item.acceptCount}</TableCell>
              <TableCell align="left" sx={{  }}>{item.rejectCount}</TableCell>
              {includeSameCount && (
                <TableCell align="left" sx={{  }}>{item.sameCount}</TableCell>
              )}
              {includeSaltCount && (
                <TableCell align="left" sx={{  }}>{item.saltCount}</TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}

export default ReportDecisionCountInfoTable;
